
import { Vue, Component, Prop } from 'vue-property-decorator';
import Model from './model';

// 必须使用@Component注解
@Component
export default class TbUserVue extends Vue {
  private model = new Model();
  private data: any = '';

  private u: string = '';
  private p: string = '';
  private pTwo: string = '';
  private inviteCode: string = '';

  // 校验参数是否正确
  private async checkParam() {
    if (this.p !== this.pTwo) {
      Vue.prototype.$message.warning('两侧输入的密码不一致');
      return false;
    } 
  }

  private async add() {
    const flag = await this.checkParam();
    if (flag === false) {
      return ;
    }
    const param = {
      data: {
        username: this.u,
        password: this.p,
      }
    };
    const result = await this.model.add(param);
    if (result) {
      if (result.code == 200) {
        Vue.prototype.$message.success('注册成功，请登录');
        this.$router.push({ path: '/login', query: {} });
      } else {
        Vue.prototype.$message.error(result.message);
      }
    } else {
      Vue.prototype.$message.error('服务异常');
    }
  }
}
